import React from 'react';
import { useHistory } from 'react-router-dom';

export type AutomationEditorTab =
  | 'builder'
  | 'automations'
  | 'run-history'
  | 'templates';

export const AutomationEditorTabs: React.FC<{
  active: AutomationEditorTab;
  automationId?: number | null;
  onTabChange: (tab: AutomationEditorTab) => void;
}> = ({ active, automationId, onTabChange }) => {
  const history = useHistory();

  const tabs: {
    id: AutomationEditorTab;
    label: string;
    onClick: () => void;
  }[] = [
    { id: 'builder', label: 'Builder', onClick: () => onTabChange('builder') },
    {
      id: 'automations',
      label: 'Automations',
      onClick: () => history.push('/automations'),
    },
    {
      id: 'run-history',
      label: 'Run history',
      onClick: () => onTabChange('run-history'),
    },
    {
      id: 'templates',
      label: 'Templates',
      onClick: () => onTabChange('templates'),
    },
  ];

  return (
    <nav className="automation-editor-tabs" aria-label="Automation sections">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={active === tab.id ? 'active' : undefined}
          disabled={tab.id === 'run-history' && !automationId}
          onClick={tab.onClick}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
};
